import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { getLocale } from "./utils/localeUtils";
import { appTranslations } from "refsix-translations";

i18next
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: "en",
        debug: false,
        lng: getLocale(),
        resources: {
            en: { translation: appTranslations.enGB },
            "en-US": { translation: appTranslations.enUS },
            it: { translation: appTranslations.it },
            da: { translation: appTranslations.da },
            de: { translation: appTranslations.de },
            es: { translation: appTranslations.es },
            fr: { translation: appTranslations.fr },
            ja: { translation: appTranslations.ja },
            nl: { translation: appTranslations.nl },
            nb: { translation: appTranslations.nb },
            pt: { translation: appTranslations.pt },
            // TODO add Polish when ready
            // pl: { translation: appTranslations.pl },
            he: { translation: appTranslations.he },
            iw: { translation: appTranslations.he }, // Also hebrew
        },
        react: { useSuspense: true },
    });
i18next.services.formatter?.add("capitalise", (value) => {
    return value.charAt(0).toUpperCase() + value.slice(1);
})
// We can use this if we don't have all the translations ready and just
// fall back to some generic or similar string
export function getStringOrFallback(key: string, fallback: string) {
    const value = i18next.t(key);
    if (!value) {
        return i18next.t(fallback);
    }
    return value;
}
